import React from 'react'
import AddSurgicalOrderForm from 'presentation/patient/components/Forms/AddSurgicalOrder/index'

export default function AppendSurgicalOrderLayout() {
  return <AddSurgicalOrderForm />
}
